module.exports = "/images/ny-life2-5.jpg";